import React from "react";
import InnerLink from './InnerLink';
import * as agent from "../agent";
import { connect } from "react-redux";
import { formatPhone } from "../utility";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import Preloader from './Preloader';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

class Users extends React.Component {

    state = {
        usersLoaded: false,
        users: []
    };

    componentDidMount = () => setTimeout(this.fetchData, 200);

    fetchData = () => {
        this.setState({ usersLoaded: false })
        agent.User.all()
            .then(users => this.setState({ users, usersLoaded: true }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }

    deleteUser = (id, fullname) => {
        const { users } = this.state;
        if(!window.confirm(`Подтвердите увольнение пользователя ${fullname.toUpperCase()}`)) {
            return;
        }
        agent.User.deleteById(id)
            .then(user => this.setState({ users: users.filter(u => u._id != id) }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }

    render() {
        const { usersLoaded, users = [] } = this.state;
        const { userPermissions } = this.props;
        const hasRootParam = (window.location.search || "").split("?").includes("root");
        return (
            usersLoaded ?
                <Table padding="checkbox">
                    <TableHead >
                        <TableRow >
                            <TableCell>ФИО</TableCell>
                            <TableCell>Телефон</TableCell>
                            <TableCell>Паспортные данные</TableCell>
                            <TableCell>Электронный адрес</TableCell>
                            { hasRootParam && userPermissions.includes("users-edit") &&
                                <TableCell title="Уволить можно только сотрудников c нулевыми правами доступа">???</TableCell>
                            }
                        </TableRow >
                    </TableHead >
                    <TableBody >
                        {users.filter(u => !u.isFired).map(({ fullname, _id, pasport: { serial, date } = {}, permissions = [], phone, email }, i) => {

                            return (
                            <TableRow key={i}>
                                <TableCell >
                                    <InnerLink href={`/user/${_id}`} label={fullname} />
                                </TableCell>
                                <TableCell >
                                    {formatPhone(phone)}
                                </TableCell>
                                <TableCell >
                                    {serial && date ? `${serial}, выдан ${date}` : "—"}
                                </TableCell>
                                <TableCell >
                                    {email}
                                </TableCell>
                                { hasRootParam && userPermissions.includes("users-edit") &&
                                  <TableCell >
                                      { permissions.length === 0 &&
                                          <IconButton onClick={() => this.deleteUser(_id, fullname)}>
                                              <DeleteIcon />
                                          </IconButton>
                                      }
                                  </TableCell>
                                }
                            </TableRow>
                        )})}
                    </TableBody>
                </Table> : <Preloader />
        )
    }
}

export default connect(null, null)(Users);



// WEBPACK FOOTER //
// ./src/components/Users.js